module.exports = __webpack_public_path__ + "static/media/QH.4f5a4480.png";